import authRoles from '../../auth/authRoles';
import StripePricesApp from './StripePricesApp';

const StripePricesAppConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: authRoles.admin,
	routes: [
		{
			path: 'admin-stripe-prices',
			element: <StripePricesApp />,
			exact: true
		},
	]
};

export default StripePricesAppConfig;
